import { useState } from 'react';

// ============================================================
// Bloc « Onglets » : contenu organisé en onglets cliquables.
// Rendu sur le site public via le moteur de blocs React.
// ============================================================

export interface TabItem {
  title: string;
  html: string;
}

export default function TabsBlock({ items }: { items: TabItem[] }) {
  const [active, setActive] = useState(0);

  if (!items || items.length === 0) return null;
  const safeIndex = active >= 0 && active < items.length ? active : 0;
  const current = items[safeIndex];

  return (
    <div className="w-full">
      <div className="flex w-fit max-w-full flex-wrap gap-1 rounded-full border border-background-200/70 bg-background-100 p-1">
        {items.map((item, i) => (
          <button
            key={`${item.title}-${i}`}
            type="button"
            onClick={() => setActive(i)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
              i === safeIndex
                ? 'bg-foreground-950 text-background-50'
                : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            {item.title}
          </button>
        ))}
      </div>
      <div
        className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base"
        dangerouslySetInnerHTML={{ __html: current?.html || '' }}
      />
    </div>
  );
}